export enum Query {
  AGENT_CONFIG = 'agent-config',
  AGENT_FEATURES = 'agent-features',
  AGENT_SESSION_BY_ID = 'agent-session-by-id',
  AGENT_SESSIONS_FILTER = 'agent-sessions-filter',
  AGENT_SESSION_LATEST = 'agent-session-latest',
  AGENT_USER = 'agent-user',
  AIML_REMEDIATION_GUIDANCE_CREATE = 'aiml-remediation-guidance-create',
  AIML_REMEDIATION_GUIDANCE_STATUS = 'aiml-remediation-guidance-status',
  AIML_REMEDIATION_GUIDANCE_RESULT = 'aiml-remediation-guidance-result',
  AIML_REMEDIATION_GUIDANCE_FEEDBACK = 'aiml-remediation-guidance-feedback',
  AI_SETTINGS = 'ai-settings',
  API_KEYS = 'api-keys',
  API_CREDENTIALS = 'api-credentials',
  APPLICATION = 'application',
  APPLICATION_INFO = 'application-info',
  APPLICATION_MODULES = 'application-modules',
  APPLICATION_POLICIES = 'application-policies',
  APPLICATION_SEARCH_FILTER = 'application-search-filter',
  APPLICATION_TAGS = 'application-tags',
  APPROVAL_WORKFLOW_FEATURE = 'approval-workflow-feature',
  APP_EXCLUSION = 'application-exclusion',
  APP_LIBRARY_STATUS_FEATURE = 'app-library-status-feature',
  ATTACK_EVENT_TAGS = 'attack-event-tags',
  AVAILABLE_AGENTS = 'available-agents',
  BUGTRACKERS = 'bugtrackers',
  CURRENT_USER_PROFILE = 'current-user-profile',
  CUSTOM_METADATA_FIELDS = 'custom-metadata-fields',
  CVE_SHIELDS_SUMMARY = 'cve-shields-summary',
  DEFAULT_ORGANIZATION = 'default-organization',
  DISA_AND_STIG_FEATURE = 'disa-and-stig-feature',
  EAC_GROUPS = 'eac-groups',
  INTEGRATIONS_APPLICATIONS = 'integrations-applications',
  INTEGRATIONS_DELETE_JIRA_CONFIGURATION = 'integrations-delete-jira-configuration',
  INTEGRATIONS_DELETE_JIRA_CREDENTIAL = 'integrations-delete-jira-credential',
  INTEGRATIONS_EPICS_JIRA = 'integrations-epics-jira',
  INTEGRATIONS_GET_JIRA_BUGTRACKER = 'integrations-get-jira-bugtracker',
  INTEGRATIONS_ISSUE_TYPES_JIRA = 'integrations-issue-types-jira',
  INTEGRATIONS_LABELS_JIRA = 'integrations-labels-jira',
  INTEGRATIONS_CREDENTIALS = 'integrations-credentials',
  INTEGRATIONS_LATEST_CREDENTIALS = 'integrations-latest-credentials',
  INTEGRATIONS_PRIORITIES_JIRA = 'integrations-priorities-jira',
  INTEGRATIONS_PROJECTS_JIRA = 'integrations-projects-jira',
  INTEGRATIONS_PROJECT_FIELDS_JIRA = 'integrations-project-fields-jira',
  INTEGRATIONS_PROJECT_STATUSES_JIRA = 'integrations-project-statuses-jira',
  INTEGRATIONS_PROJECT_USERS_JIRA = 'integrations-project-users-jira',
  INTEGRATIONS_RESOLUTIONS_JIRA = 'integrations-resolutions-jira',
  INTEGRATIONS_RULES = 'integrations-rules',
  INTEGRATIONS_SERVERLESS_ACCOUNTS = 'integrations-serverless-accounts',
  INTEGRATIONS_TEST_BUGTRACKER = 'integrations-test-bugtracker',
  INTEGRATIONS_TWO_WAY_URL_JIRA = 'integrations-two-way-url-jira',
  JOB_OUTCOME_POLICIES = 'job-outcome-policies',
  METADATA_FIELDS = 'metadata-fields',
  NEW_NOTIFICATIONS = 'new-notifications',
  NEW_NOTIFICATIONS_COUNT = 'new-notifications-count',
  ONBOARDING_SERVICE = 'onboarding-service',
  ORGANIZATION = 'organization',
  ORGANIZATION_PROFILE = 'organization-profile',
  ORGANIZATION_SETTINGS = 'organization-settings',
  OSS_INVENTORY_MODE_FEATURE = 'oss-inventory-mode-feature',
  PROTECT_RULES_QUICK_FILTERS = 'protect-rules-quick-filters',
  PROTECT_RULES_SUMMARY = 'protect-rules-summary',
  RECENT_APPLICATIONS = 'recent-applications',
  RBAC_RESOURCE_GROUPS = 'rbac-resource-groups',
  ROUTE_COVERAGE_SNAPSHOT = 'route-coverage-snapshot',
  ROUTE_OBSERVATIONS = 'route-observations',
  ROUTE_SERVERS = 'route-servers',
  RULES = 'rules',
  SCM_ONBOARDING = 'scm-onboarding',
  SIR_ONBOARDING_CONFIG = 'sir-onboarding-config',
  SOURCE_NAMES = 'source-names',
  TEAMSERVER_URL = 'teamserver-url',
  TOTAL_APP_CUSTOM_AGENT_SESSION = 'total-app-custom-agent-session',
  VULNERABILITY_TTR_PROPERTIES = 'vulnerability-ttr-properties',
  VR_AGGREGATIONS = 'vr-aggregations',
  VR_LICENSES = 'vr-licenses',
  VR_OPEN_CLOSED_VULNS = 'vr-open-closed-vulns',
  VR_RATINGS = 'vr-ratings',
  VR_ROUTE_COVERAGE = 'vr-route-coverage',
  VR_VULNERABILITIES = 'vr-vulnerabilities',
  VULN_APPROVAL_WORKFLOW_PENDING_STATUS = 'vuln-approval-workflow-pending-status',
  VULN_AUTO_VERIFICATION_FEATURE = 'vuln-auto-verification-feature',
  VULN_TRENDS_GRAPH_FEATURE = 'vuln-trends-chart-feature',
  WEBHOOKS = 'webhooks',
  VULN_BULK_XML_ASYNC_DOWNLOAD = 'vuln-bulk-xml-async-download',
  VULN_BULK_CSV_ASYNC_DOWNLOAD = 'vuln-bulk-csv-async-download',
  ASYNC_RESET_APPLICATION = 'async-reset-application',
  FREE_TRIAL_ACTIVATION = 'free-trial-activation'
}
